/* eslint import/no-named-as-default: "off",
          import/no-named-as-default-member: "off",
          no-console: "off",
          no-unused-expressions: "off"
*/
import Recorder from './recorder';

let input;
let recorderInstance;
let audioContext;
let onEndCallBack = null;
let source = null;

const recorderPlayer = {

  startRecording(func) {
    console.log('start recording');
    this.setOnEndCallBack(func);
    recorderInstance && recorderInstance.record();
  },
  stopRecording() {
    recorderInstance && recorderInstance.stop();
    this.saveStream();
    recorderInstance && recorderInstance.clear();
  },

  saveStream() {
    recorderInstance.getBuffer((buffers) => {
      if (buffers.length > 0 && buffers[0].length > 0) {
        const newBuffer = audioContext.createBuffer(1, buffers[0].length, audioContext.sampleRate);
        newBuffer.getChannelData(0)
          .set(buffers[0]);

        onEndCallBack(newBuffer, buffers);
      }
    });
  },
  play(audioBuffer, callback) {
    console.log('playing recording');
    source = audioContext.createBufferSource();

    source.buffer = audioBuffer;
    source.loop = false;
    source.connect(audioContext.destination);

    source.start();
    source.onended = callback;
  },

  stop() {
    if (source !== null) {
      source.stop();
      source = null;
    }
  },

  init(audioCtx, onPermissionCallBack) {
    audioContext = audioCtx;
    this.setup(onPermissionCallBack);
  },
  setup(onPermissionCallBack) {
    const getMic = navigator.mediaDevices.getUserMedia({
      audio: true,
    });

    getMic.then((mediaStream) => {
      input = audioContext.createMediaStreamSource(mediaStream);
      recorderInstance = new Recorder(input);
      onPermissionCallBack(true);
    });

    getMic.catch((err) => {
      console.error(err.name);
      onPermissionCallBack(false);
    });
  },

  setOnEndCallBack(func) {
    if (typeof func === 'function') {
      onEndCallBack = func;
    }
  },
};

export default recorderPlayer;



// WEBPACK FOOTER //
// ./src/modules/recorderplayer.js